// Checkbox.styles.js
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid ${(props) => (props.isError ? 'rgba(255, 102, 0, 1)' : 'rgba(97, 203, 201, 0.5)')};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  background-color: ${(props) => (props.isChecked ? 'rgba(97, 203, 201, 1)' : '#fff')};
  transition: all 0.2s ease-in-out;
  position: relative;

  &:hover {
    background-color: ${(props) => (!props.isDisabled && 'rgba(97, 203, 201, 1)')};
  }
`;

export const Checkmark = styled.img`
  width: 16px;
  height: 16px;
  opacity: ${(props) => (props.isDisabled ? '0.5' : '1')};
  display: ${(props) => (props.isChecked ? 'block' : 'none')};
  object-fit: contain;
  margin: 0 !important;
  transform: none !important;
  vertical-align: middle;
`;


